<template>
	<div class="ui-tabbar-wrapper">
		<div class="tabbar-wrapper">
			<ul>
				<template v-for="item in staticData" >

					<template v-if="item.link == 'QQ'">
						<a class="item qq" href="mqqwpa://im/chat?chat_type=wpa&uin=2850767267&version=1&src_type=web&web_src=cubemars.com" :key="item.link" v-if="!lang">
							<img :src="item.bgurl" />
							<i class="i">{{ item.name }}</i>
						</a>
					</template>

					<template v-else-if="item.link == 'skype'">
						<a class="item skype" href="skype:live:.cid.1ea837e08f6339c9?call" :key="item.link" v-if="lang" onclick="return skypeCheck();">
							<img :src="item.bgurl" />
							<i class="i">{{ item.name }}</i>
						</a>
					</template>

					<li class="item" :key="item.link" v-else
						@click="setCurrentActive(item)" :class="{ currentavtive: currentItem == item.link }"
					>
						<img :src="item.bgurl" v-if="currentItem != item.link" />
						<img :src="item.activeBgurl" v-if="currentItem == item.link" />
						<span v-if="cartNumber > 0 && item.link == 'cart' && isOnline"> {{ getCarCount }}</span>
						<p v-if="item.name == $t('common.tabbar_my_name') && isHasUnreadCount"></p>
						<i class="i">{{ item.name }}</i>
					</li>
				</template>

			</ul>
		</div>
	</div>
</template>
<script type="text/javascript" src="http://www.54kefu.net/images/skypeCheck40.js"></script>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
	data() {
		return {
			lang: false,
			staticData: [
				{
					name: this.$i18n.t('tabbar.home'),
					link: 'home',
					bgurl: require('../../assets/image/tabbar-icon/tabbar_home_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_home_sel@2x.png'),
					isActive: true
				},
				{
					name: this.$i18n.t('tabbar.QQ'),
					link: 'QQ',
					bgurl: require('../../assets/image/tabbar-icon/tabbar_qq_nor@2x.png'),
					isActive: false
				},
				{
					name: this.$i18n.t('tabbar.service'),
					link: 'skype',
					bgurl: require('../../assets/image/tabbar-icon/tabbar_service_nor@2x.png'),
					isActive: false
				},
				{
					name: this.$i18n.t('tabbar.category'),
					link: 'category',
					bgurl: require('../../assets/image/tabbar-icon/tabbar_sort_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_sort_sel@2x.png'),
					isActive: false
				},
				{
					name: this.$i18n.t('tabbar.cart'),
					link: 'cart',
					params: { type: 1 },
					bgurl: require('../../assets/image/tabbar-icon/tabbar_cart_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_cart_sel@2x.png'),
					isActive: false
				},
				{
					name: this.$i18n.t('tabbar.profile'),
					link: 'profile',
					bgurl: require('../../assets/image/tabbar-icon/tabbar_profile_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_profile_sel@2x.png'),
					isActive: false
				}
			],
			currentItem: this.$store.state.tabBar.currentTabBar
				? this.$store.state.tabBar.currentTabBar
				: 'home'
		}
	},
	created() {
		this.lang = localStorage.lang !='zh_cn'
		console.log(this.lang)
	},
	computed: {
		...mapState({
			currentTabBar: state => state.tabBar.currentTabBar,
			cartNumber: state => state.tabBar.cartNumber,
			isOnline: state => state.auth.isOnline,
			messageHint: state => state.tabBar.messageHint
		}),
		...mapGetters({
			isHasUnreadCount: 'isHasUnreadCount'
		}),
		getCarCount() {
			if (this.cartNumber > 0 && this.cartNumber < 100) {
				return this.cartNumber
			} else if (this.cartNumber >= 100) {
				return '99+'
			}
		}
	},

	watch: {
		currentTabBar: function(value) {
			let data = this.staticData
			for (let i = 0; i <= data.length - 1; i++) {
				if (value == data[i].link) {
					this.currentItem = data[i].link
				}
			}
			if (value !== 'category') {
				this.resetCurrentCategoryItem()
			}
		}
	},

	methods: {
		...mapMutations({
			resetCurrentCategoryItem: 'resetCurrentCategoryItem'
		}),
		gotoPage(path) {
			this.$router.push(path)
		},

		setCurrentActive(item) {
			this.currentItem = item.link
			this.$router.push({ name: item.link, params: item.params })
		}
	}
}
</script>

<style scoped lang="scss">
.ui-tabbar-wrapper {
	position: fixed;
	left: 0px;
	right: 0px;
	bottom: 0px;
	width: 100%;
	height: auto;
	padding: 0px;
	margin: 0px;
	background-color: #000;
	border-top: 1px solid #000 ;
	.tabbar-wrapper {
		ul {
			display: flex;
			-webkit-display: flex;
			-moz-display: flex;
			width: auto;
			justify-content: space-around;
			align-content: center;
			align-items: center;
			height: 50px;
			color: #fff;
			.item {
				&.skype {
					color: #fff;
				}
				&.qq {
					color: #fff;
				}
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: center;
				position: relative;
				img {
					@include wh(28px, 28px);
					@include ilc();
					display: $block;
				}
				.i {
					font-style: normal;
					font-size: 12px;
					text-transform: uppercase;
					line-height: 12px;
					margin-bottom: 4px;
				}
				span {
					position: absolute;
					background: #fff;
					font-size: 10px;
					color: #000;
					border-radius: 20px;
					min-width: 15px;
					line-height: 10px;
					height: 14px;
					font-weight: normal;
					text-align: center;
					top: 0px;
					display: inline-block;
					margin-left: 10px;
					padding: 2px;
				}
				p {
					width: 7px;
					height: 7px;
					position: absolute;
					right: 0px;
					top: 8%;
					background-color: $primaryColor;
					border-radius: 50%;
				}
			}
			li.currentavtive {
				.i {
					color: #FFF600;
				}
				span {
					background: #FFF600;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/Tabbar.vue